import React, { useEffect, useState, useRef } from "react";
import useAxiosPrivate from "../hooks/useAxiosPrivate";
import { useNavigate } from "react-router-dom";


const Dropdown = (props) => {
    let navigate = useNavigate();
    const [showMenu, setShowMenu] = useState(false);
    const [optionData, setOptionData] = useState([]);
    const [dropdownValue, setDropdownValue] = useState("");
    const axiosPrivate = useAxiosPrivate();
    const inputRef = useRef();

    const dropdownDetails = async (value) => {
        setDropdownValue(value)
        if (value.length > 2) {
            setShowMenu(false)
            let url = ""
            url = process.env.REACT_APP_BASE_URL + "/v1/dropdowns?search_key=" +encodeURIComponent(value)+ "&access_token=" + process.env.REACT_APP_DATA_API_SECRET_KEY;
            const cdresponse = await axiosPrivate.get(url);
            let userData = cdresponse.data
            let tempData = []
            userData.forEach(item => {
                let optionLabel = item.display_name
                let optionValue = ""
                if (item.search_ind === "stocks") {
                    optionValue = item.stock_symbol
                } else {
                    optionValue = item.shareholder_id
                }
                let optionIndicator = item.search_ind

                tempData.push({ optionLabel, optionValue, optionIndicator})
            })
            setOptionData(tempData)
            setShowMenu(true)
        } else {
            setShowMenu(false)
        }

    }

    const handleSearch = (ind, searchVal) => {
        setDropdownValue("")
        props.setShowSearchArea(false)
        if (ind === "stocks") {
            setShowMenu(false)
           // props.setShowSearchArea(false)
            navigate("/Company/" + searchVal)
            
        } else {
            setShowMenu(false)
          //  props.setShowSearchArea(false)
            navigate("/Investor/" + searchVal)
            
        }
    }

    const SearchIcon = () => (
        <svg
            width="25"
            height="25"
            viewBox="0 0 100 100"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <circle cx="38" cy="40" r="20.5" stroke="currentColor" strokeWidth="7" />
            <path
                d="M76.0872 84.4699C78.056 86.4061 81.2217 86.3797 83.158 84.4109C85.0943 82.442 85.0679 79.2763 83.099 77.34L76.0872 84.4699ZM50.4199 59.2273L76.0872 84.4699L83.099 77.34L57.4317 52.0974L50.4199 59.2273Z"
                fill="currentColor"
            />
        </svg>
    )


    useEffect(() => {
        const handler = (e) => {
            if (inputRef.current && !inputRef.current.contains(e.target)) {
                setShowMenu(false);
            }
        };

        window.addEventListener("click", handler);
        return () => {
            window.removeEventListener("click", handler);
        };
    });
    

    return (
        <div className="dropdown-container Searchbox" ref={inputRef}>
            <div style={{ display: "grid", gridTemplateColumns:"90% 10%" }}>
                <input type="text" style={{ border: "none" }} placeholder="Search for a stock or shareholder" value={dropdownValue} onChange={(e) => dropdownDetails(e.target.value)} />
                <SearchIcon />
            </div>
            {showMenu && <div style={{ position: "absolute", zIndex: "100", textAlign: "left", width: "350px", height: "250px" }}>
                <div style={{ paddingTop: "10px", backgroundColor: "white", width: "350px", height: "250px", overflowY: "auto", overflowX:"hidden" }}>
                    {optionData.map(data => (
                        <div className="dropdownOption" style={{ padding: "5px", cursor: "pointer" }} onClick={() => handleSearch(data.optionIndicator, data.optionValue)}>{data.optionLabel}</div>
                        ))
                    }
                </div>
            </div>}
        </div>
    );
}
    ;

export default Dropdown;
